module.exports = __webpack_public_path__ + "img/159-42cae4.png";